module.exports = __webpack_public_path__ + "static/media/coinbase-wallet.2f605b25.png";